//import React, { useEffect, useState } from "react";
import { useKeycloak } from "@react-keycloak/web";
import React, { useEffect, useState } from "react";
import { IFilterMessage, dtoToFilter, filterToQuery, getDefaultFilterMessage } from "../../models/interfaces/IFilterMessage";
import { ISorter } from "../../models/interfaces/ISorter";

// import CpntDropdownPage from "../../components/dataTable/CpntDropdown";
// import CpntDataTable from "../../components/dataTable/CpntDataTable";
import { ITitle } from "../../models/interfaces/ITitle";
import { ILocation } from "../../models/interfaces/ILocation";
import { IMessageList } from "../../models/interfaces/IMessage";
import CpntDataTable from "../../components/dataTable/CpntDataTable";

import CpntPagination from "../../components/CpntPagination";
import DemandesFilter from "./components/DemandesFilter";
import { useFetchBOmessagesQuery } from "../../redux/slice/api/BO/messageApi";
import HtmlRenderTypeReponseMessage from "../../components/HtmlRender/HtmlRenderTypeReponseMessage";
import HtmlRenderTypeDemandeNoticeMarqueBO from "../../components/HtmlRender/HtmlRenderTypeDemandeNoticeMarqueBO";
import SpinnerEditeurPro from "../FO/components/SpinnerEditeurPro";



const PageBODemandes: React.FC = () => {
  const [listfilter, setListFilter] = useState<IFilterMessage>();
  const [searchParams, setSearchParams] = useState<IFilterMessage>();
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [isDescending, setIsDescending] = useState<boolean>();
  const [sortField, setSortField] = useState("");
  const [numberOfResults, setNumberOfResults] = useState<number|null>(null);
  //const [initiateDownload, setInitiateDownload] = useState(false)
  //const [csvDataToDownload, setCsvDataToDownload] = useState(null)
 
  // //const [editeur, setediteur] = useState(""); // État local pour stocker la valeur de l'entrée
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  
  useEffect(() => {
    
    const storedFilter = localStorage.getItem("IFilterDemandes");
    const storedSorter = localStorage.getItem("ISortStore");

    console.log(storedFilter);
    if (storedFilter !== null && storedFilter !== undefined) { // && storedSorter !== null && storedSorter !== undefined) {
      setListFilter(JSON.parse(storedFilter));
    } else {
      setListFilter(getDefaultFilterMessage());
    }

    if (storedSorter !== null && storedSorter !== undefined) {
      const currSorter:ISorter = JSON.parse(storedSorter);
      currSorter?.orderedcolumnid && setSortField(currSorter?.orderedcolumnid);
      currSorter?.orderedasc && setIsDescending(!currSorter?.orderedasc);
    }
   
  }, []);

  useEffect(() => {
    if (listfilter && listfilter !== getDefaultFilterMessage()) {
      const _filter: IFilterMessage = filterToQuery({
        ...listfilter,
        ...(sortField && { SortField: sortField }),
        ...(isDescending !== null && { IsDescending: isDescending }),
        ...(limit >= 0 && { Limit: limit }),
        ...(offset >= 0 && limit >= 0 && { Offset: offset })
      });
     //console.log("_filter",_filter);
      setSearchParams(_filter);
      localStorage.setItem("IFilterDemandes",JSON.stringify(_filter));
    }
  }, [listfilter, sortField, isDescending, offset, limit]);

  const { data: MessagesResult, isFetching, error } = useFetchBOmessagesQuery(searchParams, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || searchParams === null || searchParams === undefined || listfilter === undefined,
  });

  useEffect(() => {
    setNumberOfResults(MessagesResult?.Quantite ?? null);
  }, [MessagesResult]);
  
  //
  const applyFilter = (data: IFilterMessage) => {
    //console.log("apply");
    setListFilter(data);
    //setOffset(0);
    //setLimit(10);
  }


  useEffect(() => {
    //console.log("listfilter");
    listfilter?.Offset && setOffset(listfilter?.Offset);
    listfilter?.Limit && setLimit(listfilter?.Limit);
  }, [listfilter])


  const actions: ILocation[] = [
    {
      PathsName: { VoirNoticeMessage: "/admin/noticedetailsmessage/[[Ean]]/[[IdNotice]]/[[Id]]"},
      State: { type_access: "" },
      ClassName: "bi-receipt Action-button",
      Visible: (index) => {
        if (MessagesResult?.Messages[index].Ean !== null ) {
          return true;
        } else {
          return false;
        }
      }
    },
    {
      PathsName: { VoirMarqueMessage: "/admin/marquedetailsmessage/[[IdMarqueExterne]]/[[Id]]"},
      State: { type_access: "" },
      ClassName: "bi-receipt Action-button NotmultipleAction",
      Visible: (index) => {
        if (MessagesResult?.Messages[index].IdMarqueExterne && MessagesResult?.Messages[index]?.IdMarqueExterne !== 0 ) {
          return true;
        } else {
          return false;
        }
      }
    },
  ];

  const dataHeaderName: ITitle[] = [
    {
      Id: "IdTypeDemande",
      Name: "Type de demande",
      Class: "",
      sorter: (a: IMessageList, b: IMessageList) => 0
    },
    {
      Id: "Ean",
      Name: "Ean",
      Class: "",
      sorter: (a: IMessageList, b: IMessageList) => 0
        //a?.Ean?.localeCompare(b?.Ean),
    },
    {
      Id: "MarqueLibelle",
      Name: "Marque",
      Class: "",
      sorter: (a: IMessageList, b: IMessageList) => 0
        //a?.MarqueLibelle?.localeCompare(b?.MarqueLibelle),
    },
    {
      Id: "PersonneDemande",
      Name: "Personne Demande",
      Class: "",
      sorter: (a: IMessageList, b: IMessageList) => 0
        //a?.PersonneDemande?.localeCompare(b?.PersonneDemande),
    },
    {
      Id: "SuiviPar",
      Name: "SuiviPar",
      Class: "",
      sorter: (a: IMessageList, b: IMessageList) => 0
        //a?.SuiviPar?.localeCompare(b?.SuiviPar),
    },
    {
      Id: "DateCreation",
      Name: "Reçu le",
      Class: "",
      sorter: (a: IMessageList, b: IMessageList) => 0
        //(a.DateCreation || "").localeCompare(b.DateCreation || "", "fr"),
    },
    {
      Id: "DateReponse",
      Name: "Traité le",
      Class: "",
      sorter: (a: IMessageList, b: IMessageList) => 0
        //(a.DateReponse || "").localeCompare(b.DateReponse || "", "fr"),
    },
    // {
    //   Id: "Nationalite",
    //   Name: "Nationalite",
    //   Class: "",
    //   sorter: (a: ISociete, b: ISociete) =>
    //     a?.Nationalite?.localeCompare(b?.Nationalite),
    // },  
    {
      Id: "IdTypeReponse",
      Name: "Type de réponse",
      Class: "",
      sorter: (a: IMessageList, b: IMessageList) => 0
        //(a?.IdTypeReponse ? a?.IdTypeReponse : -1) - (b?.IdTypeReponse ? b?.IdTypeReponse : -1),
    },
    {
      Id: "PersonneReponse",
      Name: "Traité par",
      Class: "",
      sorter: (a: IMessageList, b: IMessageList) => 0
        //a?.PersonneReponse?.localeCompare(b?.PersonneReponse),
    },
  ];


  const dataItemsStyle = {
    IdTypeDemande: <HtmlRenderTypeDemandeNoticeMarqueBO />,
    Ean:"",
    MarqueLibelle:"",
    PersonneDemande:"",
    SuiviPar:"",
    DateCreation:"",
    DateReponse:"",
    IdTypeReponse: <HtmlRenderTypeReponseMessage />,
    PersonneReponse:"",
    };

  return (
    <>
     <div className="container text-start ">
     <div className="row pt-3 pb-5">
        <div className="col col-12 ">
          <h2 className="titreModule titre-bleu"><i className="bi-chat-left-text pe-2" />Gestion des demandes par message</h2>
        </div>
      </div>
      <div className="row card mb-3 mt-2">
          {searchParams && (
            <>
              <DemandesFilter
                filter={dtoToFilter(searchParams)}
                changeFilter={applyFilter}
              />
            {/* Facettes */}
            </>
          )}
           
        </div> 
        <div className="row ">
          {numberOfResults !== null && MessagesResult?.Messages && 
            <div className="col-auto pb-3 pt-3">
              Nb de résultats :<b>&nbsp;{numberOfResults}&nbsp;</b>
                    </div>
          }
          {isFetching ? (
          <SpinnerEditeurPro />
          ) : error ? (
            <div>Error</div>
          ) : (
            MessagesResult?.Messages && numberOfResults !== null && numberOfResults > 0 &&
              <>
              <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>

              <div className="card p-0 mb-2">
                <div className="table-responsive">
                  <CpntDataTable
                    data={MessagesResult && MessagesResult?.Messages ? [...MessagesResult.Messages] : []}
                    dataHeader={dataHeaderName}
                    dataItemsStyle={dataItemsStyle}
                    actions={actions}
                    actualFilterPage="PagBODemandes"
                    updateSorter={setSortField}
                    updateDescending={setIsDescending}
                />
                </div>
              </div>
              <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>

              </>
          )}
        </div>
      </div>
    </>);
};

export default PageBODemandes;


